import React from 'react';
import DatePicker from './DatePicker';
import RangePicker from './RangePicker';
import commonUtils from '../../utils/commonUtils';
import {
  Moment,
  ForMatter,
  formatMoment
} from '../../utils/momentUtils';

import {
  IABSDatePickerProps as IProps,
  IPickerProps,
  IRangePickerProps
} from './interface';
import PickerHelper from './helper/pickerHelper';
import { defaultResult } from '../../utils/Validator';

interface IState {
  pickerValue?: Moment | string;
  result?: any;
}
/***
 * DatePicker
 * @author lidong
 *
 * 时间选择器，包含单个时间选择器，范围时间的选择器，
 * 分钟的选择器暂时没支持，在后续版本中扩展
 * 年份的选择器由于版本为升级，在后续版本中更新
 */
class ABSDatePicker extends React.Component<IProps, IState> {
  static defaultProps = {
    type: 'date',
    picker: 'date',
    isVertical: false,
    rules: []
  };

  private datePickerRef: any;
  private rangePickerRef: any;

  private format: string;

  private pickerHelper: PickerHelper = new PickerHelper();

  constructor(props: IProps) {
    super(props);
    this.state = this.pickerHelper.initState(props);
    const { picker, format } = props;
    this.format = format || ForMatter[picker || 'date'];
  }

  componentDidUpdate(prevProps: IProps) {
    const { defaultValue, value } = this.props;
    if (value === undefined) {
      if (!commonUtils.isEqual(defaultValue, prevProps.defaultValue)) {
        this.setState({ pickerValue: defaultValue || undefined });
      }
    } else {
      // 解决propsValue初始值为undefined时，stateValue存值，导致后期无法清空底层value问题
      if (this.state.pickerValue !== undefined) {
        this.setState({ pickerValue: undefined });
      }
    }
    const { onSetToday } = this.props;
    if (onSetToday) {
      onSetToday();
    }
  }

  renderDatePicker() {
    const { value, ...rest } = this.props;
    const { pickerValue, result } = this.state;
    return (
      <DatePicker
        {...rest}
        result={result}
        value={value === undefined ? pickerValue : value}
        format={this.format}
        onChange={this.onChange}
        refs={ref => {
          this.datePickerRef = ref;
        }}
      />
    );
  }

  render() {
    const { type } = this.props;
    if (type === 'range') {
      return (
        <RangePicker
          {...this.props}
          refs={ref => {
            this.rangePickerRef = ref;
          }}
        />
      );
    }
    return this.renderDatePicker();
  }

  onChange = (date: Moment | any, dateString?: string | any) => {
    const { onChange, value } = this.props;
    if (value === undefined) {
      this.setState(
        {
          pickerValue: date ? formatMoment(date, this.format) : undefined
        },
        () => this.validatorValue()
      );
    }
    if (onChange) {
      onChange(date, dateString);
    }
  };

  /**
   *  ref的方法
   */

  validatorValue(value?: any) {
    const { type, picker, rules = [], required } = this.props;
    if (picker === 'year' && type === 'date' && this.datePickerRef) {
      return this.datePickerRef.validatorValue();
    }
    if (type === 'range') {
      return this.rangePickerRef.validatorValue();
    }
    if (!rules.length && !required) {
      return defaultResult;
    }
    const result = this.pickerHelper.validatorWithMsg(this.props, this.state, value);
    this.setState({ result });
    return result;
  }

  getValue = () => {
    const { picker, type } = this.props;
    if (picker === 'year' && type === 'date' && this.datePickerRef) {
      return this.datePickerRef.getValue();
    }
    if (type === 'range' && this.rangePickerRef) {
      return this.rangePickerRef.getValue();
    }
    const { pickerValue } = this.state;
    return pickerValue ? formatMoment(pickerValue) : undefined;
  };

  reset = () => {
    const { defaultValue, picker, type } = this.props;
    if (picker === 'year' && type === 'date' && this.datePickerRef) {
      this.datePickerRef.reset();
      return;
    }
    if (type === 'range' && this.rangePickerRef) {
      this.rangePickerRef.reset();
      return;
    }
    this.setState({
      pickerValue: defaultValue || undefined,
      result: defaultResult
    });
  };

  setValue = (value: string) => {
    this.setState(
      {
        pickerValue: value ? formatMoment(value, this.format) : undefined
      },
      () => this.validatorValue()
    );
  };
}

export { IProps as IABSDatePickerProps, IRangePickerProps, IPickerProps };

export default ABSDatePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/index.tsx